import { useTheme } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import { IDarkTheme } from "styles/darkTheme";
import styles from "./styles";
export type IStatsCardProps = {
  statPercent: string;
  statTitle: string;
  statDescription: string;
  statImg: string;
};
const StatsCard = ({
  statPercent,
  statDescription,
  statImg,
  statTitle
}: IStatsCardProps) => {
  const theme = useTheme<IDarkTheme>();
  const classes = styles();
  return (
    <Stack direction="column" gap={"16px"} alignItems={"center"}>
      <img
        src={statImg}
        alt={"stats img"}
        width={100}
        height={100}
        loading="lazy"
      />
      <p className={classes.statTitle}>
        <span style={{ color: theme.colors.secondary.secondary_50 }}>
          {statPercent}{" "}
        </span>
        {statTitle}
      </p>
      <p className={classes.statDescription}>{statDescription}</p>
    </Stack>
  );
};

export default StatsCard;
